var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-section',{attrs:{"bgcolor":"bg-white"}},[_c('section-heading',{attrs:{"pre":"Contact Us"}},[_vm._v("Get in Touch")]),_c('contact-form')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }